import { useAtomValue } from "jotai";
import { Navigate, Outlet } from "react-router-dom";
import {
  activeUserAtom,
  isActiveUserEngineerStudioManagerOrArtistAtom,
} from "../../atoms/user/activeUserAtom";
import { isActiveUserSingleAccountType } from "../../utils/utils";
import { SCREENS } from "../screens";
import { ROUTE_PREFIXES } from "../index";

export const ValidDashboardRoutes = () => {
  const isActiveUserEngineerStudioManagerOrArtist = useAtomValue(
    isActiveUserEngineerStudioManagerOrArtistAtom,
  );
  const activeUser = useAtomValue(activeUserAtom);
  if (activeUser && !isActiveUserEngineerStudioManagerOrArtist) {
    if (isActiveUserSingleAccountType(activeUser!, "listener")) {
      return <Navigate to={ROUTE_PREFIXES.MY_MUSIC} />;
    }
    return <Navigate to={SCREENS.PROJECTS.replace(":tab", "today")} />;
  }

  if (!activeUser) {
    return <Navigate to={SCREENS.SIGNED_OUT_HOME_SCREEN} />;
  }

  return <Outlet />;
};
